import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { shareTableChange } from './actions'

function mapStateToProps(state, hocProps) {
    const module = _.get(hocProps, 'module', null)
    const block = _.get(hocProps, 'block', null)
    const id = _.get(hocProps, 'id', null)

    return {
        customData: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData']),
        data: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'share', 'table', 'data']),
        pagination: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'share',
            'table',
            'pagination',
        ]),
        filter: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'share', 'table', 'filter']),
        sorted: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', 'share', 'table', 'sorted']),
        isLoading: state.getIn([
            'ui',
            'workspace',
            module,
            id,
            'blocks',
            block,
            'customData',
            'share',
            'table',
            'isLoading',
        ]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            shareTableChange,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
